import dotProp from 'dot-prop-immutable';

import * as sharedTypes from 'shared/redux/actionTypes';
import { rejectNullDeep } from 'shared/utils';

import * as types from '../actionTypes';

const defaultState = {
  currentBetId: undefined,
  presetBetBasedAt: undefined,
  quickOverview: {
    isLoading: false,
    data: undefined,
    error: null,
  },
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.CHANGE_CURRENT_BET:
      return {
        ...defaultState,
        currentBetId: action.payload,
      };

    case types.CLEAR_CURRENT_BET:
      return defaultState;

    case types.SET_CURRENT_BET_PRESET_BASED_AT:
      return {
        ...state,
        presetBetBasedAt: action.payload,
      };

    case types.REQUEST_QUICK_OVERVIEW:
      return dotProp.set(state, 'quickOverview', props => ({
        ...props,
        isLoading: true,
        error: null,
      }));

    case types.RECEIVE_QUICK_OVERVIEW: {
      const { presetBetBasedAt } = action.payload.stake;

      return {
        ...state,
        presetBetBasedAt: presetBetBasedAt || state.presetBetBasedAt,
        quickOverview: {
          data: rejectNullDeep(action.payload),
          isLoading: false,
          error: null,
        },
      };
    }

    case types.RECEIVE_QUICK_OVERVIEW_ERROR:
      return dotProp.set(state, 'quickOverview', {
        data: undefined,
        isLoading: false,
        error: action.payload,
      });

    case types.CLEAR_QUICK_OVERVIEW:
      return dotProp.set(state, 'quickOverview', {
        data: undefined,
        isLoading: false,
        error: null,
      });

    case sharedTypes.DELETE_USER:
      return defaultState;

    default:
      return state;
  }
}
